import React from 'react'
import Form from 'react-bootstrap/Form'
import InputGroup from 'react-bootstrap/InputGroup'

class Emails extends React.Component {
  onChange = (e) => {
    let { value } = e.target
    const { index, email } = this.props
    let objChange = {
      endereco: value,
    }
    if (email.id) {
      objChange.id = email.id
    }
    this.props.onChange(index, objChange)
  }

  render() {
    const { email, index, disableAll, required } = this.props
    return (
      <Form.Group className={required ? 'required mb-0' : 'mb-0'}>
        <Form.Label htmlFor={`enderecoEmail-${index}`} className="small mb-1 font-weight-normal text-muted">
          E-mail
        </Form.Label>
        <InputGroup>
          <InputGroup.Prepend>
            <InputGroup.Text className="bg-light text-muted border-right-0">@</InputGroup.Text>
          </InputGroup.Prepend>
          <Form.Control
            required={required}
            type="email"
            id={`enderecoEmail-${index}`}
            name={`enderecoEmail${index}`}
            value={email.endereco || ''}
            onChange={this.onChange}
            maxLength={100}
            disabled={disableAll}
            placeholder="nome@exemplo.com"
          />
        </InputGroup>
      </Form.Group>
    )
  }
}

export default Emails
